import type { Ref } from 'vue';
import type { ItemList, WithContext } from 'schema-dts';
import { useHead } from '#app/composables/head';
import { useRuntimeConfig } from '#app/nuxt';
import { serializeJsonLd } from '~/utils/serializeJsonLd';

type ItemWithOldIdentifier = {
  old_identifier: string;
};

/**
 * 一覧データからschema.orgのItemList形式のJSON-LDを生成する
 * @see https://schema.org/ItemList
 * @see https://developers.google.com/search/docs/appearance/structured-data/carousel
 */
export function useItemListJsonLd(
  items: Ref<ItemWithOldIdentifier[] | null | undefined>,
  basePath: string,
) {
  const config = useRuntimeConfig();

  useHead(() => {
    if (!items.value?.length) {
      return {};
    }

    const jsonLd: WithContext<ItemList> = {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      itemListElement: items.value.map((item, index) => ({
        '@type': 'ListItem' as const,
        position: index + 1,
        url: `${config.public.siteUrl}${basePath}${item.old_identifier}`,
      })),
    };

    return {
      script: [
        {
          type: 'application/ld+json',
          innerHTML: serializeJsonLd(jsonLd),
        },
      ],
    };
  });
}
